var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileEmoji = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m.205 10c1.561.015 2.795.206 2.795 1 0 .828-1.343 2-3 2s-3-1.172-3-2 1.343-1 3-1ZM7.5 6.5c.828 0 1.5.895 1.5 2s-.672 2-1.5 2S6 9.605 6 8.5s.672-2 1.5-2m7 0c.828 0 1.5.895 1.5 2s-.672 2-1.5 2-1.5-.895-1.5-2 .672-2 1.5-2"
})));
export default SvgTiktokMobileEmoji;